import styled from 'styled-components';

import { flexStyle, gutterStyle } from '../../styles';

export const Wrapper = styled.div`
  ${flexStyle}
  ${gutterStyle}

  && {
    min-width: 100%;
  }
`;
